import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref} from 'vue';
import TbContent from '@/components/app_content/tb_content.vue';
import {useTable} from "@/components/app_content/tb_content_data";
import {useCheckPage} from "./h_check_page_data";
import {ElLoading} from "element-plus";

// 定义数据类型
interface Tb {
  "idCardNo": string,
  "phone": string,
  "price": string,
  "transAmt": string,
  "rePayTime": string | null,
  "payTime": string,
  "state": string,
  "type": string,
  "reqSeqId": string,
  "reqDate": string,
  "isD": boolean | null,
}



export default /*@__PURE__*/_defineComponent({
  __name: 'h_check_page',
  setup(__props) {

const defaultTbItem: Tb = {
  idCardNo: '',
  phone: '',
  price: '',
  transAmt: '',
  rePayTime: null,
  payTime: '',
  state: '',
  type: '',
  reqSeqId: '',
  reqDate: '',
  isD: false  // 在这里设置默认值
};
// 1. 定义共享数据状态
const sharedTableData = ref<Tb[]>([defaultTbItem])

// 2. 使用页面逻辑（支持外部传入状态实现动态变化）
const {onSubmit} = useCheckPage(
    sharedTableData,
    () => {
      // onSubmit();
    }
)

// 3. 初始化表格逻辑，传入共享数据引用
const {handleEdit, handleDelete,handleOder} = useTable(sharedTableData, () => {
  const loadingInstance = ElLoading.service({fullscreen: true})
  setTimeout(() => {
    loadingInstance.close();
    onSubmit()
  }, 3000); // 1000毫秒 = 1秒
});

// 初始加载
onSubmit();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TbContent, {
    tableData: sharedTableData.value,
    handleEdit: _unref(handleEdit),
    handleDelete: _unref(handleDelete),
    handleOder: _unref(handleOder)
  }, null, 8, ["tableData", "handleEdit", "handleDelete", "handleOder"]))
}
}

})